var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-time-input"},[_c('input',{ref:"input",staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"TT.MM.JJJJ HH:MM"}})])}
var staticRenderFns = []

export { render, staticRenderFns }